import { render, staticRenderFns } from "./build-summary.vue?vue&type=template&id=78f6f8e2"
import script from "./build-summary.vue?vue&type=script&lang=js"
export * from "./build-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports